import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import i18n from "i18next";
import { Link } from 'react-router-dom'
import Context from '../../Store/Context';


const  pathDarkTheme = "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z";
const pathLightTheme = "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z";

const classSearch = "TopNav_searchBarHide__AOdnA TopNav_searchBarVisible__uFE9L";
const classNoneSearch = "TopNav_searchBarHide__AOdnA false";

const classSearchTablet  = "TopNavTablet_searchBarHide__7kAXp TopNavTablet_searchBarVisible__IW9iS";
const classNonSearchTablet = "TopNavTablet_searchBarHide__7kAXp false";


function HeaderCpn(){



    const [state,dispatch] = useContext(Context);

    // const [lang,setLang] = useState('vie');


    // const [selectMenu,setSelectMenu] = useState('home');

    const { t } = useTranslation("translation");

    const changeTheme = (value) =>{
      dispatch({'theme':value,'type':"change_theme"})
    }

    // const changeLang = (value) =>{
    //   i18n.changeLanguage(value); 
    //   dispatch({'language':value,'type':"change_language"});
      
    // }
    
    // const changeLanguage = (e) => {
    //   const languageValue = e.target.value
    //   i18n.changeLanguage(languageValue);      

    //   dispatch({'type':'change_language','language':languageValue})
    // }

    // const onclickMenu = (name) =>{
    //     setSelectMenu(name);
    //     var menu = document.getElementById("navbarNav");
    //     menu.classList.remove("show");

    //     var buttonMenu = document.getElementById("buttonMenuNavbar");
    //     buttonMenu.classList.add("collapsed");
    //     buttonMenu.setAttribute("aria-expanded","false");

    // }

    // const onclickCurrency = (e) =>{
    //     dispatch({'type':'change_currency','currency':e.target.value})
    // }

    const closeMenuSmall = ()=>{
      let temp = document.getElementById("menuTablet").getAttribute("class")
      if(temp === "TopNavTablet_menuBarHide___XJeu false"){
        document.getElementById("menuTablet").setAttribute("class","TopNavTablet_menuBarHide___XJeu TopNavTablet_menuBarVisible__dMf6d");
        document.getElementById("iconMenuTablet").setAttribute("d","M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z");
        document.getElementById("svgMenuTablet").setAttribute("viewBox","0 0 1024 1024");
      }
      else{
        document.getElementById("menuTablet").setAttribute("class","TopNavTablet_menuBarHide___XJeu false");
        document.getElementById("iconMenuTablet").setAttribute("d","M32 96v64h448V96H32zm0 128v64h448v-64H32zm0 128v64h448v-64H32z");
        document.getElementById("svgMenuTablet").setAttribute("viewBox","0 0 512 512");
      }
    }


    const onclickLight = ()=>{
        let theme =  window.localStorage.getItem("theme");
        if(!theme ||  theme === "light")
        {
           theme = "dark"
           document.getElementById("pathTheme").setAttribute("d",pathDarkTheme);
           document.getElementById("pathTheme2").setAttribute("d",pathDarkTheme);
           document.getElementById("pathTheme3").setAttribute("d",pathDarkTheme);
        }
         
        else
        {
          theme = "light";
          document.getElementById("pathTheme").setAttribute("d",pathLightTheme);
          document.getElementById("pathTheme2").setAttribute("d",pathLightTheme);
          document.getElementById("pathTheme3").setAttribute("d",pathLightTheme);
        }
         
        document.documentElement.setAttribute("data-theme",theme)
        window.localStorage.setItem("theme",theme);
        
        changeTheme(theme);
     
    }


    // const onclickLang = ()=>{
    //   let language =  window.localStorage.getItem("language");
    //   if(!language ||  language === "vie")
    //   {
    //        language = "eng";
    //   }
    //   else
    //   {
    //         language = "vie";
    //   }

    //   window.localStorage.setItem("language",language);
    //   changeLang(language);
    //   setLang(language);
    // }

    const onclickIconSearch = ()=>{
      // document.getElementById("divSearch").setAttribute("class",classSearch);
    
    }


    const getTheme = ()=>{
       let temp =window.localStorage.getItem("theme");
       if(!temp || temp === "light")
        return "black";
        
       else
        return "white";
          
    }
    

   useEffect(()=>{
    let theme = localStorage.getItem("theme");
    if(!theme || theme === "light"){
        theme = 'light';
        document.getElementById("pathTheme").setAttribute("d",pathLightTheme);
    }
    else{
        document.getElementById("pathTheme").setAttribute("d",pathDarkTheme);
    }
    
    document.documentElement.setAttribute("data-theme",theme);

    window.addEventListener('click', function(e){   
     
      if (document.getElementById('iconSearch').contains(e.target))
      {
        if((this.document.getElementById("divSearch").getAttribute("class"))===classNoneSearch)
          document.getElementById("divSearch").setAttribute("class",classSearch);
        else
        document.getElementById("divSearch").setAttribute("class",classNoneSearch);
      } 
      
      else if(!document.getElementById("divSearch").contains(e.target))
      {
        document.getElementById("divSearch").setAttribute("class",classNoneSearch);
      }



      // tablet
      if (document.getElementById('iconSearch2').contains(e.target))
        {
          if((document.getElementById("divSearch2").getAttribute("class"))===classNonSearchTablet)
            document.getElementById("divSearch2").setAttribute("class",classSearchTablet);
          else
          document.getElementById("divSearch2").setAttribute("class",classNonSearchTablet);
        } 
        
        else if(!document.getElementById("divSearch2").contains(e.target))
        {
          document.getElementById("divSearch2").setAttribute("class",classNonSearchTablet);
        }



    });

   },[])


    return (
        <>
        <div className="Layout_topNav__8V9r_">
          <div className="TopNav_mainDiv__cuKYv">
            <nav className="TopNav_nav__zY_6d">
              <div className="TopNav_topBar__tch_k">
                <div className="TopNav_leftDiv__BEVjX">
                  <Link to="/newsletters/">
                    <div className="TopNav_itemUpDiv__gZtnp">Bản tin</div>
                  </Link>
                  {/* <a href="/videos/">
                    <div className="TopNav_itemUpDiv__gZtnp">Videos</div>
                  </a> */}
                  <a
                    href="https://hub.coinbureau.com/research-feed/"
                    className="TopNav_clubNavDiv__2u8BC"
                  >
                    <div className="TopNav_club__7aob_">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 640 512"
                        className="TopNav_clubIcon__9cpnw"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z" />
                      </svg>{" "}
                      Club
                    </div>
                  </a>
                </div>
                <div className="TopNav_logoDiv__e2pGB" style={{marginLeft:"-15px"}}>

              
                    <Link to="/">
                        <img
                        alt="Coin Bureau"
                        fetchpriority="high"
                        decoding="async"
                        data-nimg="fill"
                        //   src="/Black.svg"
                        // src="https://h2tmediagroup.com/wp-content/uploads/2024/03/Logo-H2T-180x60-1.png"
                        src="/asset/images/logo3.png"
                        style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0,
                            objectFit: "contain",
                            color: "transparent"
                        }}
                        />

                        <span style={{position:"absolute",marginLeft:"25px",top:"10px",fontSize:"20px",fontWeight:"900",color:"red"}}>
                          H2T
                          <span style={{display:"block"}}>
                            MEDIA GROUP
                          </span>
                        </span>
                        
                    </Link>

                  
              
                

                </div>
              
                <div className="TopNav_rightDiv__YqPDt">
                  <div>
                    <div  className="TopNav_searchDiv__0JIlC">
                      <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="TopNav_searchIcon__LOoxf"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        id="iconSearch"
                        onClick={()=>{onclickIconSearch()}}
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                      <div id="divSearch" className="TopNav_searchBarHide__AOdnA false">
                        <div className="SearchNav_mainDiv__IuIL5">
                          <div className="SearchNav_searchDiv__AIZsz">
                            <div className="SearchNav_searchBar__3BumA">
                              <div className="SearchNav_searchIconDiv__eKLY3">
                                <svg
                                  stroke="currentColor"
                                  fill="none"
                                  strokeWidth={2}
                                  viewBox="0 0 24 24"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="SearchNav_searchIcon__YsNmW"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle cx={11} cy={11} r={8} />
                                  <line x1={21} y1={21} x2="16.65" y2="16.65" />
                                </svg>
                              </div>
                              <div className="SearchNav_searchInputDiv__8DVdO">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  defaultValue=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="TopNav_colorModeDiv__g7TCr" onClick={()=>{onclickLight()}}>
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth={0}
                      viewBox="0 0 16 16"
                      className="TopNav_modeIcon__N2RdN"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path id="pathTheme" d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
                    </svg>
                  </div>

                  {/* <div className="TopNav_colorModeDiv__g7TCr" onClick={()=>{onclickLang()}}>
                {lang === 'vie'?   <svg
                  viewBox="0 0 36 36"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--twemoji"
                  preserveAspectRatio="xMidYMid meet"
                  fill="#000000"

                   height="2em"
                      width="2em"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    <path
                      fill="#DA251D"
                      d="M32 5H4a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"
                    />
                    <path
                      fill="#FF0"
                      d="M19.753 16.037L18 10.642l-1.753 5.395h-5.672l4.589 3.333l-1.753 5.395L18 21.431l4.589 3.334l-1.753-5.395l4.589-3.333z"
                    />
                  </g>
                  </svg>
                  :
                  <svg viewBox="0 -4 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" height="2em" width="2em">
                  <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <g clipPath="url(#clip0_503_2952)">
                      {" "}
                      <rect width={28} height={20} rx={2} fill="white" />{" "}
                      <mask
                        id="mask0_503_2952"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x={0}
                        y={0}
                        width={28}
                        height={20}
                      >
                        {" "}
                        <rect width={28} height={20} rx={2} fill="white" />{" "}
                      </mask>{" "}
                      <g mask="url(#mask0_503_2952)">
                        {" "}
                        <rect width={28} height={20} fill="#0A17A7" />{" "}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M-1.28244 -1.91644L10.6667 6.14335V-1.33333H17.3334V6.14335L29.2825 -1.91644L30.7737 0.294324L21.3263 6.66667H28V13.3333H21.3263L30.7737 19.7057L29.2825 21.9165L17.3334 13.8567V21.3333H10.6667V13.8567L-1.28244 21.9165L-2.77362 19.7057L6.67377 13.3333H2.95639e-05V6.66667H6.67377L-2.77362 0.294324L-1.28244 -1.91644Z"
                          fill="white"
                        />{" "}
                        <path
                          d="M18.668 6.33219L31.3333 -2"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          d="M20.0128 13.6975L31.3666 21.3503"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          d="M8.00555 6.31046L-3.83746 -1.67099"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          d="M9.29006 13.6049L-3.83746 22.3105"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0 12H12V20H16V12H28V8H16V0H12V8H0V12Z"
                          fill="#E6273E"
                        />{" "}
                      </g>{" "}
                    </g>{" "}
                    <defs>
                      {" "}
                      <clipPath id="clip0_503_2952">
                        {" "}
                        <rect width={28} height={20} rx={2} fill="white" />{" "}
                      </clipPath>{" "}
                    </defs>{" "}
                  </g>
                </svg>

                    } 




                  </div> */}


                  <div className="TopNav_logInDiv__oprxC">
                    <a href="https://hub.coinbureau.com/sign-in/">
                      <button>Log In</button>
                    </a>
                  </div>
                  <div className="TopNav_signUpDiv__T_8MR">
                    <a href="https://hub.coinbureau.com/sign-up/">
                      <button>Sign Up</button>
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="TopNav_bottomBar__ZZ0uu">
                <div className="TopNav_itemDiv__K2xqP">
                  <span style={{ paddingRight: 5 }}> Bài viết </span>{" "}
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 512 512"
                    className="TopNav_downArrow__Zjwgv"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z" />
                  </svg>
                  <div className="TopNav_dropdownMenu__oM2UD">
                    <div className="ArticlesNav_mainDiv__5f2w5">
                      <div className="ArticlesNav_articleDropdown__Z6lQf">
                        <div className="ArticlesNav_leftDiv__oBfAd">
                          <div className="ArticlesNav_articleListHeader__ktWmE">
                            Top Resources
                          </div>
                          <div>
                            <a href="/services/crypto-tax-software/">
                              <div className="ArticlesNav_articleList__NCViH">
                                Best Crypto Tax Software in 2025: Top 7 Tax Tools for
                                Crypto
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/review/top-crypto-telegram-channels/">
                              <div className="ArticlesNav_articleList__NCViH">
                                The Top 10 Best Crypto Telegram Channels
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/analysis/top-crypto-youtubers/">
                              <div className="ArticlesNav_articleList__NCViH">
                                10 Best Crypto YouTube Channels to Watch in 2025
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/analysis/best-hardware-wallets/">
                              <div className="ArticlesNav_articleList__NCViH">
                                5 Best Hardware Wallets for 2025: Top Crypto Wallets
                                Reviewed!
                              </div>
                            </a>
                          </div>
                          <div className="ArticlesNav_articleListFooter__G_j3a">
                            <a href="/category/analysis/">
                              VIEW ALL TOP RESOURCES &nbsp;{" "}
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth={0}
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z" />
                              </svg>
                            </a>
                          </div>
                        </div>
                        <div className="ArticlesNav_middleDiv___HaHN">
                          <div className="ArticlesNav_articleListHeader__ktWmE">
                            Beginner Education
                          </div>
                          <div>
                            <a href="/education/what-is-bitcoin/">
                              <div className="ArticlesNav_articleList__NCViH">
                                What is Bitcoin? A Simple Explanation
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/education/what-is-ethereum/">
                              <div className="ArticlesNav_articleList__NCViH">
                                Ethereum 101: The Ultimate Guide to Understanding
                                Ethereum
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/education/what-is-blockchain-technology/">
                              <div className="ArticlesNav_articleList__NCViH">
                                What is Blockchain in Simple Terms?
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/education/ethereum-smart-contracts/">
                              <div className="ArticlesNav_articleList__NCViH">
                                What is a Smart Contract? Contracts on the Blockchain!
                              </div>
                            </a>
                          </div>
                          <div className="ArticlesNav_articleListFooter__G_j3a">
                            <a href="/category/education/">
                              VIEW ALL BEGINNER EDUCATION &nbsp;{" "}
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth={0}
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z" />
                              </svg>
                            </a>
                          </div>
                        </div>
                        <div className="ArticlesNav_rightDiv__zdOOn">
                          <div className="ArticlesNav_articleListHeader__ktWmE">
                            Hot Reviews
                          </div>
                          <div>
                            <a href="/review/binance/">
                              <div className="ArticlesNav_articleList__NCViH">
                                Binance Review 2025: Pros &amp; Cons and In-Depth
                                Exchange Overview
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/review/okx/">
                              <div className="ArticlesNav_articleList__NCViH">
                                OKX Review 2025: Powerful All-In-One Crypto Exchange!
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/review/trezor-models-compared/">
                              <div className="ArticlesNav_articleList__NCViH">
                                Trezor Review: Trezor One Vs Trezor Model T, Which is
                                Best for You?
                              </div>
                            </a>
                          </div>
                          <div>
                            <a href="/review/koinly-review/">
                              <div className="ArticlesNav_articleList__NCViH">
                                Koinly Review 2025: Crypto Tax Made Easy!
                              </div>
                            </a>
                          </div>
                          <div className="ArticlesNav_articleListFooter__G_j3a">
                            <a href="/category/review/">
                              VIEW ALL HOT REVIEWS &nbsp;{" "}
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth={0}
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z" />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="TopNav_itemDiv__K2xqP">
                  <span style={{ paddingRight: 5 }}>Danh mục</span>{" "}
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 512 512"
                    className="TopNav_downArrow__Zjwgv"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z" />
                  </svg>
                  <div className="TopNav_dropdownMenu__oM2UD">
                    <div className="CategoriesNav_mainDiv__k_L3O">
                      <div className="CategoriesNav_categoryDropdown__4gqKl">
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <Link to="/blog/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">
                                All Categories
                              </div>
                              <div className="CategoriesNav_description__YxurQ">
                                Learn everything you need to know
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/education/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">Education</div>
                              <div className="CategoriesNav_description__YxurQ">
                                Blockchain and crypto education is where it all starts.
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/defi/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">DeFi</div>
                              <div className="CategoriesNav_description__YxurQ">
                                DeFi, or decentralized finance, is working to replace
                                centralized traditional finance.
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/adoption/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">Adoption</div>
                              <div className="CategoriesNav_description__YxurQ">
                                Cryptocurrency adoption is needed to make these digital
                                assets go mainstream.
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/review/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">Reviews</div>
                              <div className="CategoriesNav_description__YxurQ">
                                Loads of cryptocurrency and blockchain project reviews
                                for your education.
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/guides/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">Guides</div>
                              <div className="CategoriesNav_description__YxurQ">
                                Our blockchain guides will help you find your way
                                through exchanges, tools, and other crypto apps.
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/trading/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">Trading</div>
                              <div className="CategoriesNav_description__YxurQ">
                                Crypto trading is a great way to get involved in the
                                blockchain revolution.
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/mining/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">Mining</div>
                              <div className="CategoriesNav_description__YxurQ">
                                Learn everything you need to know about crypto mining
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="CategoriesNav_categoryDiv__ZsHs1">
                          <a href="/category/news/">
                            <div className="CategoriesNav_categoryList__uEIAe">
                              <div className="CategoriesNav_name__P8czP">News</div>
                              <div className="CategoriesNav_description__YxurQ">
                                Crypto markets move fast. Let us keep you up to date
                                with our detailed crypto news coverage.
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="TopNav_itemDealDiv__x1mWc">
                  <Link to="/deals/">Giao dịch</Link>
                </div>
                
                <div className="TopNav_itemDiv__K2xqP">
                  <Link
                    // href="https://store.coinbureau.com/"
                    to="/all_coin"
                    id="merch_store_id"
                    aria-label="go to store"
                  >
                   Tiền ảo
                  </Link>
                </div>
                
                {/* <div className="TopNav_itemDiv__K2xqP">
                  <a href="/about/">About</a>
                </div> */}
                
                <div className="TopNav_itemDiv__K2xqP">
                  <span style={{ paddingRight: 5 }}>Liên hệ </span>{" "}
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 512 512"
                    className="TopNav_downArrow__Zjwgv"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z" />
                  </svg>
                  <div className="TopNav_dropdownMenu__oM2UD">
                    <div className="ContactNav_mainDiv__eUxZW">

                      <div className="Footer_socialList__vm376" style={{marginBottom:"15px",marginLeft:"20px"}}>
                        {/* <div className="Footer_discord__FXrWL">
                          <a
                            href="https://go.coinbureau.com/cb-discord"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="go to discord"
                          >
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth={0}
                              viewBox="0 0 16 16"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z" />
                            </svg>
                          </a>
                        </div> */}
                        <div className="Footer_twitter__GQvLZ">
                          <a
                            href="https://twitter.com/coinbureau"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="go to twitter"
                          >
                            <svg
                              stroke={getTheme()}
                              fill={getTheme()}
                              strokeWidth={0}
                              viewBox="0 0 16 16"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
                            </svg>
                          </a>
                        </div>
                        
                        <div className="Footer_youtube__6u3OY">
                          <a
                            href="https://www.youtube.com/channel/UCqK_GSMbpiV8spgD3ZGloSw"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="go to youtube"
                          >
                            <svg
                              stroke={getTheme()}
                              fill={getTheme()}
                              strokeWidth={0}
                              viewBox="0 0 16 16"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                            </svg>
                          </a>
                        </div>
                        
                        <div className="Footer_linkedin__DKAX2">
                          <a
                            href="https://www.linkedin.com/company/coin-bureau"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="go to linkedin"
                          >
                            <svg
                              stroke={getTheme()}
                              fill={getTheme()}
                              strokeWidth={0}
                              viewBox="0 0 512 512"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/>
                            </svg>
                          </a>
                        </div>
                      
                      </div>


                      {/* <div className="ContactNav_categoryDropdown__o_rtO">





                        
                        <div className="ContactNav_categoryDiv__YNMEe">
                          <a href="/contact">
                            <div className="ContactNav_categoryList__Mgkzz">
                              <div className="ContactNav_name__TPrgg">
                                General Inquiries
                              </div>
                              <div className="ContactNav_description__TEgtb">
                                Have questions? Feel free to reach out and we’ll be in
                                touch
                              </div>
                            </div>
                          </a>
                        </div>
                        
                        <div className="ContactNav_categoryDiv__YNMEe">
                          <a href="/careers/">
                            <div className="ContactNav_categoryList__Mgkzz">
                              <div className="ContactNav_name__TPrgg">Work With Us</div>
                              <div className="ContactNav_description__TEgtb">
                                Are you crypto-obsessed like us and want to share your
                                Knowledge with the world? Check out our job postings or
                                drop us a CV
                              </div>
                            </div>
                          </a>
                        </div>
                        
                        
                        <div className="ContactNav_categoryDiv__YNMEe">
                          <a href="/write-for-us/">
                            <div className="ContactNav_categoryList__Mgkzz">
                              <div className="ContactNav_name__TPrgg">Write For Us</div>
                              <div className="ContactNav_description__TEgtb">
                                Want to put your penmanship to the test in the dynamic
                                world of crypto? We’d love to hear from you!
                              </div>
                            </div>
                          </a>
                        </div>
                        
                        
                        <div className="ContactNav_categoryDiv__YNMEe">
                          <a href="/press-release-inquiry/">
                            <div className="ContactNav_categoryList__Mgkzz">
                              <div className="ContactNav_name__TPrgg">
                                Press Release Inquiry
                              </div>
                              <div className="ContactNav_description__TEgtb">
                                Have some exciting news &amp; developments to share with
                                our community? Inquire about Press Release services
                                here!
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="ContactNav_categoryDiv__YNMEe">
                          <a href="/review-inquiry/">
                            <div className="ContactNav_categoryList__Mgkzz">
                              <div className="ContactNav_name__TPrgg">
                                Review Inquiry
                              </div>
                              <div className="ContactNav_description__TEgtb">
                                Building an exciting project that you want to share with
                                the world? Let us review it and spread the word!
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="ContactNav_categoryDiv__YNMEe">
                          <a href="/content-update-request/">
                            <div className="ContactNav_categoryList__Mgkzz">
                              <div className="ContactNav_name__TPrgg">
                                Content Update Request
                              </div>
                              <div className="ContactNav_description__TEgtb">
                                One of our articles in need of a refresh &amp; update?
                                Give us a shout!
                              </div>
                            </div>
                          </a>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>


        {/* di dong  */}
        <div className="Layout_topNavTablet__080Ge">
          <div className="TopNavTablet_mainDiv__LP0Kw">
            <nav className="TopNavTablet_nav__9vA1l">
              <div className="TopNavTablet_topBar__sM_eh">
                <div className="TopNavTablet_leftDiv__SgTIN" >
                  <div className="TopNavTablet_hamburgerDiv__9JRZf" onClick={()=>{
                  
                  closeMenuSmall();
                 
                }}>
                    <svg
                    id="svgMenuTablet"
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth={0}
                      viewBox="0 0 512 512"
                      className="TopNavTablet_hamburgerIcon__YtAoX"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"

                      onClick={()=>{}}
                    >
                      <path id="iconMenuTablet" d="M32 96v64h448V96H32zm0 128v64h448v-64H32zm0 128v64h448v-64H32z" />
                    </svg>
                  </div>
                  <div id="menuTablet" className="TopNavTablet_menuBarHide___XJeu false">
                    <div className="MenuBar_menuDropdown__OJHj1">
                      <div>
                        <div className="MenuBar_topDiv__cPZ6f">
                          <div className="MenuBar_searchBar__vWWHZ">
                            <div className="SearchNavTablet_mainDiv__sHvLd">
                              <div className="SearchNavTablet_searchDiv__SB0ay">
                                <form>
                                  <div className="SearchNavTablet_searchBar__sNJqX">
                                    <div className="SearchNavTablet_searchIconDiv__F51w_">
                                      <svg
                                        stroke="currentColor"
                                        fill="none"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="SearchNavTablet_searchIcon__1kmAm"
                                        height="1em"
                                        width="1em"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx={11} cy={11} r={8} />
                                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                                      </svg>
                                    </div>
                                    <div className="SearchNavTablet_searchInputDiv__CUMRP">
                                      <input
                                        type="text"
                                        placeholder="Search"
                                        defaultValue=""
                                      />
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          
                          <div className="MenuBar_colorModeDiv__mW5rW" onClick={()=>{onclickLight()}}>
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth={0}
                              viewBox="0 0 16 16"
                              className="MenuBar_modeIcon__iFETf"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path id="pathTheme2" d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
                            </svg>
                          </div>

                          {/* <div className="MenuBar_colorModeDiv__mW5rW" onClick={()=>{onclickLang()}}>
                          {lang === 'vie'?   <svg
                  viewBox="0 0 36 36"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--twemoji"
                  preserveAspectRatio="xMidYMid meet"
                  fill="#000000"

                   height="2em"
                      width="2em"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    <path
                      fill="#DA251D"
                      d="M32 5H4a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"
                    />
                    <path
                      fill="#FF0"
                      d="M19.753 16.037L18 10.642l-1.753 5.395h-5.672l4.589 3.333l-1.753 5.395L18 21.431l4.589 3.334l-1.753-5.395l4.589-3.333z"
                    />
                  </g>
                  </svg>
                  :
                  <svg viewBox="0 -4 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" height="2em" width="2em">
                  <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <g clipPath="url(#clip0_503_2952)">
                      {" "}
                      <rect width={28} height={20} rx={2} fill="white" />{" "}
                      <mask
                        id="mask0_503_2952"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x={0}
                        y={0}
                        width={28}
                        height={20}
                      >
                        {" "}
                        <rect width={28} height={20} rx={2} fill="white" />{" "}
                      </mask>{" "}
                      <g mask="url(#mask0_503_2952)">
                        {" "}
                        <rect width={28} height={20} fill="#0A17A7" />{" "}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M-1.28244 -1.91644L10.6667 6.14335V-1.33333H17.3334V6.14335L29.2825 -1.91644L30.7737 0.294324L21.3263 6.66667H28V13.3333H21.3263L30.7737 19.7057L29.2825 21.9165L17.3334 13.8567V21.3333H10.6667V13.8567L-1.28244 21.9165L-2.77362 19.7057L6.67377 13.3333H2.95639e-05V6.66667H6.67377L-2.77362 0.294324L-1.28244 -1.91644Z"
                          fill="white"
                        />{" "}
                        <path
                          d="M18.668 6.33219L31.3333 -2"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          d="M20.0128 13.6975L31.3666 21.3503"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          d="M8.00555 6.31046L-3.83746 -1.67099"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          d="M9.29006 13.6049L-3.83746 22.3105"
                          stroke="#DB1F35"
                          strokeWidth="0.666667"
                          strokeLinecap="round"
                        />{" "}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0 12H12V20H16V12H28V8H16V0H12V8H0V12Z"
                          fill="#E6273E"
                        />{" "}
                      </g>{" "}
                    </g>{" "}
                    <defs>
                      {" "}
                      <clipPath id="clip0_503_2952">
                        {" "}
                        <rect width={28} height={20} rx={2} fill="white" />{" "}
                      </clipPath>{" "}
                    </defs>{" "}
                  </g>
                </svg>
                

                    } 

                          </div> */}
                        
                        </div>
                        
                        
                        <a href="#articleNav">
                          <div className="MenuBar_menuBarDiv__9CIru" onClick={()=>{
                           let temp = document.getElementById("articleNav").getAttribute("class");
                           if(temp === "MenuBar_inactiveDropdownMenu__2r0f2")
                           {
                              temp ="MenuBar_activeDropdownMenu__yzRSU"
                           }
                             
                          else
                          {
                              temp ="MenuBar_inactiveDropdownMenu__2r0f2"
                          }
                           
                          document.getElementById("articleNav").setAttribute("class",temp);

                          }}>
                            <div className="MenuBar_menuBarList__wtSfT">
                              <div className="MenuBar_name__R_85z">
                                <span style={{ paddingRight: 5 }}> Bài viết </span>{" "}
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth={0}
                                  viewBox="0 0 512 512"
                                  className="MenuBar_downArrow__cMRw0"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                        <div
                          className="MenuBar_inactiveDropdownMenu__2r0f2"
                          id="articleNav"
                        >
                          <div className="ArticlesNav_mainDiv__5f2w5">
                            <div className="ArticlesNav_articleDropdown__Z6lQf">
                              <div className="ArticlesNav_leftDiv__oBfAd">
                                <div className="ArticlesNav_articleListHeader__ktWmE">
                                  Top Resources
                                </div>
                                <div>
                                  <a href="/services/crypto-tax-software/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      Best Crypto Tax Software in 2025: Top 7 Tax Tools
                                      for Crypto
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/review/top-crypto-telegram-channels/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      The Top 10 Best Crypto Telegram Channels
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/analysis/top-crypto-youtubers/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      10 Best Crypto YouTube Channels to Watch in 2025
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/analysis/best-hardware-wallets/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      5 Best Hardware Wallets for 2025: Top Crypto
                                      Wallets Reviewed!
                                    </div>
                                  </a>
                                </div>
                                <div className="ArticlesNav_articleListFooter__G_j3a">
                                  <a href="/category/analysis/">
                                    VIEW ALL TOP RESOURCES &nbsp;{" "}
                                    <svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      strokeWidth={0}
                                      viewBox="0 0 1024 1024"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z" />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                              <div className="ArticlesNav_middleDiv___HaHN">
                                <div className="ArticlesNav_articleListHeader__ktWmE">
                                  Beginner Education
                                </div>
                                <div>
                                  <a href="/education/what-is-bitcoin/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      What is Bitcoin? A Simple Explanation
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/education/what-is-ethereum/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      Ethereum 101: The Ultimate Guide to Understanding
                                      Ethereum
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/education/what-is-blockchain-technology/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      What is Blockchain in Simple Terms?
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/education/ethereum-smart-contracts/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      What is a Smart Contract? Contracts on the
                                      Blockchain!
                                    </div>
                                  </a>
                                </div>
                                <div className="ArticlesNav_articleListFooter__G_j3a">
                                  <a href="/category/education/">
                                    VIEW ALL BEGINNER EDUCATION &nbsp;{" "}
                                    <svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      strokeWidth={0}
                                      viewBox="0 0 1024 1024"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z" />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                              <div className="ArticlesNav_rightDiv__zdOOn">
                                <div className="ArticlesNav_articleListHeader__ktWmE">
                                  Hot Reviews
                                </div>
                                <div>
                                  <a href="/review/binance/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      Binance Review 2025: Pros &amp; Cons and In-Depth
                                      Exchange Overview
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/review/okx/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      OKX Review 2025: Powerful All-In-One Crypto
                                      Exchange!
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/review/trezor-models-compared/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      Trezor Review: Trezor One Vs Trezor Model T, Which
                                      is Best for You?
                                    </div>
                                  </a>
                                </div>
                                <div>
                                  <a href="/review/koinly-review/">
                                    <div className="ArticlesNav_articleList__NCViH">
                                      Koinly Review 2025: Crypto Tax Made Easy!
                                    </div>
                                  </a>
                                </div>
                                <div className="ArticlesNav_articleListFooter__G_j3a">
                                  <a href="/category/review/">
                                    VIEW ALL HOT REVIEWS &nbsp;{" "}
                                    <svg
                                      stroke="currentColor"
                                      fill="currentColor"
                                      strokeWidth={0}
                                      viewBox="0 0 1024 1024"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z" />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a href="#categoryNav">
                          <div className="MenuBar_menuBarDiv__9CIru" onClick={()=>{
                           let temp = document.getElementById("categoryNav").getAttribute("class");
                           if(temp === "MenuBar_inactiveDropdownMenu__2r0f2")
                           {
                              temp ="MenuBar_activeDropdownMenu__yzRSU"
                           }
                             
                          else
                          {
                              temp ="MenuBar_inactiveDropdownMenu__2r0f2"
                          }
                           
                          document.getElementById("categoryNav").setAttribute("class",temp);

                          }}>
                            <div className="MenuBar_menuBarList__wtSfT">
                              <div className="MenuBar_name__R_85z">
                                <span style={{ paddingRight: 5 }}> Danh mục </span>{" "}
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth={0}
                                  viewBox="0 0 512 512"
                                  className="MenuBar_downArrow__cMRw0"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                        <div
                          className="MenuBar_inactiveDropdownMenu__2r0f2"
                          id="categoryNav"
                        >
                          <div className="CategoriesNav_mainDiv__k_L3O">
                            <div className="CategoriesNav_categoryDropdown__4gqKl">
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <Link to="/blog/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      All Categories
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Learn everything you need to know
                                    </div>
                                  </div>
                                </Link>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/education/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      Education
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Blockchain and crypto education is where it all
                                      starts.
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/defi/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      DeFi
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      DeFi, or decentralized finance, is working to
                                      replace centralized traditional finance.
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/adoption/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      Adoption
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Cryptocurrency adoption is needed to make these
                                      digital assets go mainstream.
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/review/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      Reviews
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Loads of cryptocurrency and blockchain project
                                      reviews for your education.
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/guides/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      Guides
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Our blockchain guides will help you find your way
                                      through exchanges, tools, and other crypto apps.
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/trading/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      Trading
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Crypto trading is a great way to get involved in
                                      the blockchain revolution.
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/mining/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      Mining
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Learn everything you need to know about crypto
                                      mining
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="CategoriesNav_categoryDiv__ZsHs1">
                                <a href="/category/news/">
                                  <div className="CategoriesNav_categoryList__uEIAe">
                                    <div className="CategoriesNav_name__P8czP">
                                      News
                                    </div>
                                    <div className="CategoriesNav_description__YxurQ">
                                      Crypto markets move fast. Let us keep you up to
                                      date with our detailed crypto news coverage.
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="MenuBar_menuBarDiv__9CIru">
                          <div className="MenuBar_menuBarList__wtSfT MenuBar_itemDealDiv__9HBRA">
                            <a href="/deals/" id="">
                              <div className="MenuBar_name__R_85z">Giao dịch</div>
                            </a>
                          </div>
                        </div>
                        <div className="MenuBar_menuBarDiv__9CIru" onClick={()=>{closeMenuSmall()}}>
                          <div className="MenuBar_menuBarList__wtSfT false">
                            <Link to="/all_coin" id="merch_store_id">
                              <div className="MenuBar_name__R_85z">Tiền ảo</div>
                            </Link>
                          </div>
                        </div>
                        {/* <div className="MenuBar_menuBarDiv__9CIru">
                          <div className="MenuBar_menuBarList__wtSfT false">
                            <a href="/newsletters/" id="">
                              <div className="MenuBar_name__R_85z">Newsletters</div>
                            </a>
                          </div>
                        </div> */}
                        {/* <div className="MenuBar_menuBarDiv__9CIru">
                          <div className="MenuBar_menuBarList__wtSfT false">
                            <a href="/videos/" id="">
                              <div className="MenuBar_name__R_85z">Videos</div>
                            </a>
                          </div>
                        </div> */}
                        {/* <div className="MenuBar_menuBarDiv__9CIru">
                          <div className="MenuBar_menuBarList__wtSfT false">
                            <a href="/about/" id="">
                              <div className="MenuBar_name__R_85z">About</div>
                            </a>
                          </div>
                        </div> */}
                        <a href="#contactNav">
                          <div className="MenuBar_menuBarDiv__9CIru"  onClick={()=>{
                           let temp = document.getElementById("contactNav").getAttribute("class");
                           if(temp === "MenuBar_inactiveDropdownMenu__2r0f2")
                           {
                              temp ="MenuBar_activeDropdownMenu__yzRSU"
                           }
                             
                          else
                          {
                              temp ="MenuBar_inactiveDropdownMenu__2r0f2"
                          }
                           
                          document.getElementById("contactNav").setAttribute("class",temp);

                          }}>
                            <div className="MenuBar_menuBarList__wtSfT">
                              <div className="MenuBar_name__R_85z">
                                <span style={{ paddingRight: 5 }}>Liên hệ </span>{" "}
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth={0}
                                  viewBox="0 0 512 512"
                                  className="MenuBar_downArrow__cMRw0"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                        <div
                          className="MenuBar_inactiveDropdownMenu__2r0f2"
                          id="contactNav"
                        >
                          <div className="ContactNav_mainDiv__eUxZW">
                            <div className="ContactNav_categoryDropdown__o_rtO">
                              
                              <div className="Footer_socialList__vm376" style={{marginBottom:"15px",marginLeft:"20px"}}>

                          <div className="Footer_twitter__GQvLZ">
                            <a
                              href="https://twitter.com/coinbureau"
                              target="_blank"
                              rel="noreferrer"
                              aria-label="go to twitter"
                            >
                              <svg
                                stroke={getTheme()}
                                fill={getTheme()}
                                strokeWidth={0}
                                viewBox="0 0 16 16"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
                              </svg>
                            </a>
                          </div>
                          
                          <div className="Footer_youtube__6u3OY">
                            <a
                              href="https://www.youtube.com/channel/UCqK_GSMbpiV8spgD3ZGloSw"
                              target="_blank"
                              rel="noreferrer"
                              aria-label="go to youtube"
                            >
                              <svg
                                stroke={getTheme()}
                                fill={getTheme()}
                                strokeWidth={0}
                                viewBox="0 0 16 16"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                              </svg>
                            </a>
                          </div>
                          
                          <div className="Footer_linkedin__DKAX2">
                            <a
                              href="https://www.linkedin.com/company/coin-bureau"
                              target="_blank"
                              rel="noreferrer"
                              aria-label="go to linkedin"
                            >
                              <svg
                                stroke={getTheme()}
                                fill={getTheme()}
                                strokeWidth={0}
                                viewBox="0 0 512 512"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/>
                              </svg>
                            </a>
                          </div>
                        
                              </div>


                              
                              {/* <div className="ContactNav_categoryDiv__YNMEe">
                                <a href="/contact">
                                  <div className="ContactNav_categoryList__Mgkzz">
                                    <div className="ContactNav_name__TPrgg">
                                      General Inquiries
                                    </div>
                                    <div className="ContactNav_description__TEgtb">
                                      Have questions? Feel free to reach out and we’ll
                                      be in touch
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="ContactNav_categoryDiv__YNMEe">
                                <a href="/careers/">
                                  <div className="ContactNav_categoryList__Mgkzz">
                                    <div className="ContactNav_name__TPrgg">
                                      Work With Us
                                    </div>
                                    <div className="ContactNav_description__TEgtb">
                                      Are you crypto-obsessed like us and want to share
                                      your Knowledge with the world? Check out our job
                                      postings or drop us a CV
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="ContactNav_categoryDiv__YNMEe">
                                <a href="/write-for-us/">
                                  <div className="ContactNav_categoryList__Mgkzz">
                                    <div className="ContactNav_name__TPrgg">
                                      Write For Us
                                    </div>
                                    <div className="ContactNav_description__TEgtb">
                                      Want to put your penmanship to the test in the
                                      dynamic world of crypto? We’d love to hear from
                                      you!
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="ContactNav_categoryDiv__YNMEe">
                                <a href="/press-release-inquiry/">
                                  <div className="ContactNav_categoryList__Mgkzz">
                                    <div className="ContactNav_name__TPrgg">
                                      Press Release Inquiry
                                    </div>
                                    <div className="ContactNav_description__TEgtb">
                                      Have some exciting news &amp; developments to
                                      share with our community? Inquire about Press
                                      Release services here!
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="ContactNav_categoryDiv__YNMEe">
                                <a href="/review-inquiry/">
                                  <div className="ContactNav_categoryList__Mgkzz">
                                    <div className="ContactNav_name__TPrgg">
                                      Review Inquiry
                                    </div>
                                    <div className="ContactNav_description__TEgtb">
                                      Building an exciting project that you want to
                                      share with the world? Let us review it and spread
                                      the word!
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="ContactNav_categoryDiv__YNMEe">
                                <a href="/content-update-request/">
                                  <div className="ContactNav_categoryList__Mgkzz">
                                    <div className="ContactNav_name__TPrgg">
                                      Content Update Request
                                    </div>
                                    <div className="ContactNav_description__TEgtb">
                                      One of our articles in need of a refresh &amp;
                                      update? Give us a shout!
                                    </div>
                                  </div>
                                </a>
                              </div> */}
                            
                            
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="MenuBar_signButtons__SS0Jw">
                      <a href="https://hub.coinbureau.com/sign-up/">
                        <div className="MenuBar_signUpDiv__mdzNY">
                          <button>Sign Up</button>
                        </div>
                      </a>
                      <a href="https://hub.coinbureau.com/sign-in/">
                        <div className="MenuBar_logInDiv__Px8fD">
                          <button>Log In</button>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="TopNavTablet_colorModeDiv__hXQtX" onClick={()=>{onclickLight()}}>
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth={0}
                      viewBox="0 0 16 16"
                      className="TopNavTablet_modeIcon__F8m5u"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path id="pathTheme3" d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
                    </svg>
                  </div>
                  <div>
                    <div className="TopNavTablet_searchDiv__2zCx8" >
                      <svg
                        id="iconSearch2"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="TopNavTablet_searchIcon__jLx1w"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                      <div id="divSearch2" className="TopNavTablet_searchBarHide__7kAXp false">
                        <div className="SearchNavTablet_mainDiv__sHvLd">
                          <div className="SearchNavTablet_searchDiv__SB0ay">
                            <form>
                              <div className="SearchNavTablet_searchBar__sNJqX">
                                <div className="SearchNavTablet_searchIconDiv__F51w_">
                                  <svg
                                    stroke="currentColor"
                                    fill="none"
                                    strokeWidth={2}
                                    viewBox="0 0 24 24"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="SearchNavTablet_searchIcon__1kmAm"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle cx={11} cy={11} r={8} />
                                    <line x1={21} y1={21} x2="16.65" y2="16.65" />
                                  </svg>
                                </div>
                                <div className="SearchNavTablet_searchInputDiv__CUMRP">
                                  <input
                                    type="text"
                                    placeholder="Search"
                                    defaultValue=""
                                  />
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="TopNavTablet_logoDiv__j4wyU" style={{marginLeft:"-5px"}}>
                  <Link to="/">
                    <img
                      alt="logo"
                      fetchpriority="high"
                      decoding="async"
                      data-nimg="fill"
                      className="TopNavTablet_logo__FVv6P"
                      // src="https://h2tmediagroup.com/wp-content/uploads/2024/03/Logo-H2T-180x60-1.png"
                      src="/asset/images/logo3.png"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        objectFit: "contain",
                        color: "transparent",
                        marginLeft:"-7px"
                      }}
                    />
                    <span className="fontsize_logo" style={{position:"absolute",marginLeft:"0px",top:"8px",fontWeight:"900",color:"red",width:"150px"}}>
                      H2T
                      <span style={{display:"block"}}>MEDIA GROUP</span>
                    </span>
                  </Link>
                </div>
                
                <div className="TopNavTablet_rightDiv__mjKam">
                  <a
                    href="https://hub.coinbureau.com/research-feed/"
                    className="TopNavTablet_clubNavDiv__hpru_"
                  >
                    <div className="TopNavTablet_club__uFSRa">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth={0}
                        viewBox="0 0 640 512"
                        className="TopNavTablet_clubIcon__ni8Po"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z" />
                      </svg>{" "}
                      Club
                    </div>
                  </a>
                  <div className="TopNavTablet_signUpDiv__c8abh">
                    <a href="https://hub.coinbureau.com/sign-up/">
                      <button>Sign Up</button>
                    </a>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
         {/* di dong  */}
        </>
   )
}

export default HeaderCpn;